import React, { useState } from "react";
import "./App.css";
import "./NavBar.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
} from "react-router-dom";
import SocialFooter from "./components/SocialFooter";
import Home from "./pages/home/Home";
import Modal from "./Modal";
import profilePhoto from "./rkb_photo.jpg";
import Template from "./pages/template/Template.jsx";

const App = () => {
  const [isModalopen, setModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return (
    <>
      <div style={{ backgroundColor: "aliceblue", minHeight: "100vh" }}>
        <Router>
          <div className="container">
            <nav className="navbar">
              <div className="navbar-top-row">
                <button className="hamburger-btn" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
                  ☰
                </button>
                <div className="navbar-header" onClick={() => setModalOpen(true)}>
                  <span className="title-rkb">Ranee Kaur Banerjee</span>
                </div>
              </div>
              <span className="navbar-subtitle">
                Word-painter. Wanderer. Woolgatherer.
              </span>
              <hr style={{ width: "100%" }} />
              <div style={{ width: "100%" }}>
                <ul className={`navbar-menu ${isMobileMenuOpen ? "mobile-open" : ""}`}>
                  <li onClick={() => setIsMobileMenuOpen(false)}>
                    <Link className="navbar-item" to={"/"}>
                      HOME
                    </Link>
                  </li>
                  <li onClick={() => setIsMobileMenuOpen(false)}>
                    <Link className="navbar-item" to={"/people"}>
                      PEOPLE
                    </Link>
                  </li>
                  <li onClick={() => setIsMobileMenuOpen(false)}>
                    <Link className="navbar-item" to={"/places"}>
                      PLACES
                    </Link>
                  </li>
                  <li onClick={() => setIsMobileMenuOpen(false)}>
                    <Link className="navbar-item" to={"/voices"}>
                      VOICES
                    </Link>
                  </li>
                  <li onClick={() => setIsMobileMenuOpen(false)}>
                    <Link className="navbar-item" to={"/faces"}>
                      FACES
                    </Link>
                  </li>
                  <li onClick={() => setIsMobileMenuOpen(false)}>
                    <Link className="navbar-item" to={"/lightbulbmoments"}>
                      LITTLE <br className="hide-on-mobile" />
                      <span style={{ background: "yellow" }}>
                        LIGHTBULB
                      </span> <br className="hide-on-mobile" /> MOMENTS
                    </Link>
                  </li>
                  <li onClick={() => setIsMobileMenuOpen(false)}>
                    <Link className="navbar-item" to={"/colourmegreen"}>
                      COLOUR ME GREEN
                    </Link>
                  </li>
                </ul>
              </div>
            </nav>
          </div>

          {isModalopen && (
            <Modal onClose={() => setModalOpen(false)}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}>
                <div>
                  <p>Dr Ranee Kaur Banerjee</p>
                  <p>
                    Words make up most of my world. I'm lucky they also make up
                    most of my livelihood as a professional editor because even
                    cosmos creators need day jobs. All I have ever achieved has
                    been based on my affinity and facility with words, my
                    visceral need to know and learn anything about everything,
                    and the uncontrollable urge to conceive and convey.{" "}
                  </p>
                </div>
                <div>
                  <img
                    style={{ height: "250px", marginRight: "10px" }}
                    src={profilePhoto}
                    alt="Ranee Kaur Banerjee Profile"
                  />
                </div>
              </div>
            </Modal>
          )}

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/people" element={<Template component={"people"} />} />
            <Route path="/places" element={<Template component={"places"} />} />
            <Route path="/voices" element={<Template component={"voices"} />} />
            <Route path="/faces" element={<Template component={"faces"} />} />
            <Route
              path="/lightbulbmoments"
              element={<Template component={"littlelightbulbmoments"} />}
            />
            <Route
              path="/colourmegreen"
              element={<Template component={"colourmegreen"} />}
            />
          </Routes>
        </Router>
        <SocialFooter />

      </div>
    </>
  );
};

export default App;
